import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { 
  formatNumberGrouped, 
  formatDecimalWithOneDecimal,
  formatNumberStripDelimiters 
} from 'util/formatters/numberFormatter';

import TextInput from 'common/TextInput';

const baseString = 'vra-zone-product-application-input';
const ZoneProductApplicationInputWeb = ({
  allowOneDecimal = false,
  isEditingDisabled,
  onBlur,
  onChange,
  onClick,
  property,
  validationResult,
  value
}) => {
  const classString = classNames({
    ['baseString']: true
  });
  
  let val = value;
  const defaultValue = formatNumberGrouped((value || value === 0) ? parseFloat(value) : '');
  let shouldShowValue = (parseFloat(defaultValue) + parseFloat(value)) >= 0;
  if (allowOneDecimal) {
    let temp = (value || value === 0) ? value.toString().replace(',','.') : '';
    if(Number(temp) >= 0 || ['0,','0.'].includes(val)) {
      shouldShowValue = true;
    }
    if(['0,0','0.0'].includes(val)) {
      val = val.substring(0,2);
      shouldShowValue = true;
    }
  }
  
  return (
    <section className={classString}>
      <TextInput
        className={`${baseString}__input`}
        dataTestId={`${baseString}__input`}
        defaultValue={shouldShowValue ? defaultValue : ''}
        disabled={isEditingDisabled}
        onBlur={onBlur}
        onChange={(e) => {
          const val = allowOneDecimal
            ? formatDecimalWithOneDecimal(e.target.value || 0)
            : formatNumberStripDelimiters(e.target.value || 0);
          onChange({ property, value: val });
        }}
        onClick={onClick}
        placeholder={defaultValue}
        validationResult={validationResult}
        value={shouldShowValue ? val : ''}
      />
    </section>
  );
};
ZoneProductApplicationInputWeb.propTypes = {
  allowOneDecimal: propTypes.bool,
  isEditingDisabled: propTypes.bool.isRequired,
  onBlur: propTypes.func,
  onChange: propTypes.func.isRequired,
  onClick: propTypes.func.isRequired,
  property: propTypes.string.isRequired,
  validationResult: propTypes.object,
  value: propTypes.string.isRequired
};
export default ZoneProductApplicationInputWeb;
